import React, { FC, useCallback } from "react";
import { StyledAssetTypeFlag } from "./asset-type.styled";
import { Grid } from "@mui/material";

import {
    IconAudio,
    IconCaption,
    IconFile,
    IconImage,
    IconVideo,
    IconPhotoType,
    IconContentsVideo,
    IconCollection,
} from "@mzc-cloudplex/icons";
import { MEDIA_TYPES } from "@constants";
import theme from "@styles/theme";

const CollectionTypeFlag = ({ minWidth, width, height }) => {
    return (
        <StyledAssetTypeFlag
            sx={{
                minWidth,
                width,
                height,
                color: theme.palette.constant.white,
                backgroundColor: theme.palette.etc.purple400,
            }}
        >
            <IconCollection size={12} />
        </StyledAssetTypeFlag>
    );
};

export default CollectionTypeFlag;
